import { QualityType } from "@/features/player/model/types";

export const VIDEO_QUALITY = {
    "360": { label: "360", value: QualityType.q360 },
    "480": { label: "480", value: QualityType.q480 },
    "720": { label: "720", value: QualityType.q720 },
    "1080": { label: "1080", value: QualityType.q1080 },
};
